import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  const top = section && sectionId !== 'inicio'
    ? Math.max(0, section.getBoundingClientRect().top + window.scrollY - 100)
    : 0;

  window.scrollTo({ top, left: 0, behavior: 'instant' });
};

export default function ScrollPosition() {
  const location = useLocation();

  useLayoutEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    // Position the destination before painting, including back/forward navigation.
    const isHome = ['/', '/page'].includes(location.pathname);
    scrollToSection(isHome ? location.state?.scrollTo : null);
  }, [location]);

  return null;
}
